import SubmitAssessmentHeader from "../../../components/SubmitAssessment/Header/SubmitAssessmentHeader";
import SubmitAssessmentCalender from "../../../utils/Images/SubmitAssessmentCalender";
import ButtonWrapper from "../CommonBtn/ButtonWrapper";
import "./QuestionList.scss";
import { useTranslation } from "react-i18next";
import Footer from "../../../components/Footer/Footer";
import { useContext, useEffect, useRef, useState } from "react";
import InstructionModal from "../InstructionModal/InstructionModal";
import { useLocation, useNavigate } from "react-router-dom";
import {
  assessmentQuestionReport,
  getApplicantAssessmentQuestion,
  submitAndSkipApplicantAssessmentAnswer,
  updateAssessmentApplicantQuestionStatus,
} from "../../../service/SubmitAssessment/SubmitAssessment";
import QuestionProgressBar from "./QuestionProgressBar";
import AnswerQuestion from "./AnswerQuestion";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import {
  captureScreenshot,
  convertToText,
  exitFullScreen,
  formatTime,
  updateProgressBarAndColors,
} from "../../../utils/Common/Constant";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { AssessmentButton, showToast } from "ui-components";
import SystemCompatibility from "../SystemCompatibility/SystemCompatibility";
import DeviceDetector from "../DeviceDetector/DeviceDetector";
import { setSessionStorageItem } from "../../../utils/SessionStorageMethod/setSessionStorageItem";
import { getSessionStorageItem } from "../../../utils/SessionStorageMethod/getSessionStorageItem";
import { removeSessionStorageItem } from "../../../utils/SessionStorageMethod/removeSessionStorageItem";
import ConfirmPopup from "./ConfirmPopup/ConfirmPopup";
import AddReport from "./AddReport";
import OrdinalShift from "../../../components/OrdinalShift/OrdinalShift";
import PlayVoice from "../../../components/PlayVoices/PlayVoice";
import Walkthrough from "../../../components/WalkThrough/Walkthrough";
import RecordingIcon from "../../../utils/Images/RecordingIcon";
import { ImageUploader } from "../../../utils/Common/MediaUploader";
import { WalkthroughContext } from "../../../context/WalkthroughContext/WalkthroughContext";
const charLimit = 1000;
type MediaPermissions = {
  mic?: boolean | null;
  camera?: boolean | null;
};
const QuestionList = () => {
  const { t, i18n } = useTranslation();
  // Get current language
  const currentLanguage = i18n.language;
  const location = useLocation();
  const navigate = useNavigate();
  const { transcript, browserSupportsSpeechRecognition, resetTranscript } =
    useSpeechRecognition();
  const { assessmentDetailsData, instructions, companyId } = location.state;
  const [questionData, setQuestionData] = useState<any>();
  const questionSet = Array(assessmentDetailsData?.totalQuestions).fill(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [isTimerComplete, setIsTimerComplete] = useState(false);
  const [singleTypeValue, setSingleTypeValue] = useState<any>();
  const [multipleTypeValue, setMultipleTypeValue] = useState([]);
  const [essayTypeValue, setEssayTypeValue] = useState("");
  const [essayCharCount, setEssayCharCount] = useState(0);
  const [subTimer, setSubTimer] = useState<any>(null);
  const [apiError, setApiError] = useState<boolean>(false);
  const [subTimerReference, setSubTimerReference] = useState<number>(0);
  const [subQuestionColors, setSubQuestionColors] = useState<any>([]);
  const [progressbar, setProgressBar] = useState({
    progressbar: 0,
    index: 0,
  });
  const [show, setShow] = useState(false);
  // check for camera, mic, internet
  const [isCheckCompatibilities, setIsCheckCompatibilities] = useState(false);
  const videoContinueRef = useRef<HTMLVideoElement>(null);
  const [micPermissions, setMicPermissions] = useState<MediaPermissions>({
    mic: null,
  });
  const [cameraPermissions, setCameraPermissions] = useState<MediaPermissions>({
    camera: null,
  });
  const [internetSpeed, setInternetSpeed] = useState<boolean | number | null>(
    null,
  );
  const [internetSpeedCount, setInternetSpeedCount] = useState<number | null>(
    null,
  );
  const [internetSpeedIsLoading, setInternetSpeedIsLoading] = useState(false);
  const [isResumeDisable, setIsResumeDisable] = useState(false);
  const [isTextToSpeechFinished, setIsTextToSpeechFinished] = useState(false);
  const [transcriptEnabled, setTranscriptEnabled] = useState(false);
  const [isBlinking, setIsBlinking] = useState(true);
  const [codingAnsTemplate, setCodingAnsTemplate] = useState("");
  const [testCases, setTestCases] = useState([]);
  const [codingSummary, setCodingSummary] = useState("");
  const [codeOutPut, setCodeOutput] = useState("");
  const [isStatus, setIsStatus] = useState("");
  const [startQuestionLoader, setStartQuestionLoader] = useState(false);
  const [disableNext, setDisableNext] = useState(true);
  const [isTabSwitchedBack, setIsTabSwitchedBack] = useState(false);
  const [isDefferedConfirm, setIsDefferedConfirm] = useState(false);
  const [addReport, setAddReport] = useState("");
  const [reportLoading, SetReportLoading] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const [isLastReportQuestion, SetIsLastReportQuestion] = useState(false);
  const [isAbortedPopup, SetIsAbortedPopup] = useState(false);
  const [isCodingQuestionEdited, SetIsCodingQuestionEdited] = useState(false);
  const [isStartRecording, SetIsStartRecording] = useState(false);
  const [cameraStopped, setCameraStopped] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("c");

  const {
    startWalkthrough,
    isHeaderWalkthroughDone,
    setIsHeaderWalkthroughDone,
  } = useContext(WalkthroughContext) || {};

  const isFirefox =
    typeof navigator !== "undefined" &&
    navigator.userAgent.toLowerCase().includes("firefox");
  const [isPlaying, setIsPlaying] = useState(false);
  const handleAudioEnd = () => {
    setIsTextToSpeechFinished(true);
    SetIsStartRecording(true);
    setTranscriptEnabled(true);
    setIsPlaying(false);
    localStorage.removeItem("firstTimeWalkThrough");
  };
  const recorderRef = useRef<any>(null);
  const visualAnalysisFunctionRef = useRef<any>(null);
  // Store the function reference when it becomes available
  useEffect(() => {
    const interval = setInterval(() => {
      if (
        recorderRef.current?.insertAIVisualAnalysisApi &&
        !visualAnalysisFunctionRef.current
      ) {
        visualAnalysisFunctionRef.current =
          recorderRef.current.insertAIVisualAnalysisApi.bind(
            recorderRef.current,
          );
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);
  const handleVisualAnalysis = async (
    companyId: any,
    assessmentId: any,
    applicantId: any,
    questionId: any,
  ) => {
    // Use stored function reference if available, otherwise try current ref
    if (visualAnalysisFunctionRef.current) {
      await visualAnalysisFunctionRef.current(
        companyId,
        assessmentId,
        applicantId,
        questionId,
      );
    } else {
      await recorderRef.current?.insertAIVisualAnalysisApi(
        companyId,
        assessmentId,
        applicantId,
        questionId,
      );
    }
  };
  useEffect(() => {
    const handleBlur = () => {
      setIsTabSwitchedBack(true);
    };
    window.addEventListener("blur", handleBlur);
    return () => {
      window.removeEventListener("blur", handleBlur);
    };
  }, []);
  // this useffect handles the disabling of next question

  useEffect(() => {
    handleDisableNext(questionData?.type);
  }, [
    singleTypeValue,
    multipleTypeValue,
    essayTypeValue,
    transcript,
    isCodingQuestionEdited,
  ]);
  const handleDisableNext = (type: string) => {
    let disable = true; // Initially, next button should be disabled
    if (type === "Single") {
      disable =
        singleTypeValue && Object.keys(singleTypeValue).length !== 0
          ? false
          : true;
    } else if (type === "Multiple") {
      disable = multipleTypeValue.length > 0 ? false : true;
    } else if (type === "Essay") {
      disable = essayTypeValue.trim().length > 0 ? false : true;
    } else if (type === "Video") {
      disable = transcript.trim().length > 0 ? false : true;
    } else if (type === "Coding") {
      disable = isCodingQuestionEdited ? false : true;
    }
    // Update the disableNext state
    setDisableNext(startQuestionLoader ? true : disable);
    return disable;
  };
  // this useEffect executes when question changes
  useEffect(() => {
    setSingleTypeValue(null);
    setMultipleTypeValue([]);
    setEssayTypeValue("");
    resetTranscript();
    setDisableNext(true);
  }, [currentQuestionIndex]);
  useEffect(() => {
    localStorage.removeItem("firstTimeWalkThrough");
  }, []);
  useEffect(() => {
    if (navigator.onLine) {
      handleApplicantAssessmentQuestion();
    }
  }, [navigator.onLine]);
  //timer for cbt question
  useEffect(() => {
    const interval = setInterval(() => {
      if (isTextToSpeechFinished) {
        if (!isCheckCompatibilities && !isTabSwitchedBack && !isAbortedPopup) {
          if (subTimer === 31) {
            setIsBlinking(true);
          }
          setSubTimer((prevTimer: number) => {
            if (prevTimer > 0) {
              return prevTimer - 1; // Decrement the timer by 1 second
            } else {
              clearInterval(interval); // Stop the interval when timer reaches 0
              resetTranscript();
              return 0;
            }
          });
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [
    subTimer,
    isCheckCompatibilities,
    isTextToSpeechFinished,
    isTabSwitchedBack,
  ]);
  // call automatically handleApplicantAssessmentQuestion when subtimer reaches 0
  useEffect(() => {
    if (!isTimerComplete) {
      if (subTimer === 0 && !apiError) {
        if (isFirefox && questionData?.type === "Video") {
          setSessionStorageItem("isStatusUpdate", "answered");
        } else {
          if (transcript) {
            setSessionStorageItem("isStatusUpdate", "answered");
          } else {
            setSessionStorageItem("isStatusUpdate", "skipped");
          }
        }
        handleAnswer();
      }
    }
  }, [subTimer, startQuestionLoader, isStatus, apiError]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleAnswer = () => {
    localStorage.removeItem("firstTimeWalkThrough");
    if (subTimer >= 0) {
      setIsTimerComplete(true);
      setSessionStorageItem("timetaken", subTimer);
      setSubTimer(0);
    }
  };
  const handleAbortedModalSave = () => {
    SetIsAbortedPopup(false);
    showToast(t("GENERAL.ASSESSMENT_TERMINATED"), "success");
    // Check if the document is in fullscreen mode and exit if true
    exitFullScreen();
    navigate(`/${currentLanguage}/feedback`, {
      state: {
        assessmentTilte: assessmentDetailsData?.title,
        applicantId: assessmentDetailsData?.applicantId,
        assessmentId: assessmentDetailsData?.assessmentId,
      },
    });
  };
  const handleTabChangeModalSave = () => {
    setIsTabSwitchedBack(false);
    handleApplicantAssessmentQuestion();
  };
  // to get next question and pass previous question answer to submitAndSkipApplicantAssessmentAnswer
  const handleNext = async (videoURL: string) => {
    const isStatusUpdate = getSessionStorageItem("isStatusUpdate");
    const submitData = {
      applicantId: assessmentDetailsData?.applicantId,
      assessmentId: assessmentDetailsData?.assessmentId,
      assessmentApplicantQuestionId:
        questionData?.assessmentApplicantQuestionId,
      questionId: questionData?.questionId,
      questionType: questionData?.types ?? questionData?.type,
      totalResponseTime: subTimerReference - getSessionStorageItem("timetaken"),
      response:
        isStatusUpdate === "answered"
          ? handleTypeAnswer(questionData?.type, videoURL)
          : "",
      meta: { summary: codingSummary },
      isFinalSubmit:
        assessmentDetailsData?.totalQuestions === currentQuestionIndex &&
          isLastReportQuestion
          ? false
          : assessmentDetailsData?.totalQuestions === currentQuestionIndex
            ? true
            : false,

      status: isStatusUpdate,
    };
    if (isStatusUpdate && isStatusUpdate?.length) {
      setStartQuestionLoader(true);
      const submitRes =
        await submitAndSkipApplicantAssessmentAnswer(submitData);
      if (submitRes?.status === 200) {
        if (submitData?.status == "answered") {
          await handleVisualAnalysis(
            companyId,
            assessmentDetailsData?.assessmentId,
            assessmentDetailsData?.applicantId,
            questionData?.assessmentApplicantQuestionId,
          );
        }
        removeSessionStorageItem("timetaken");
        if (submitData?.isFinalSubmit) {
          showToast(
            `${t("SUBMIT_ASSESSMENT_ASSESSMENT_SUBMITTED")}`,
            "success",
          );
          // Check if the document is in fullscreen mode and exit if true
          if (document.fullscreenElement) {
            document.exitFullscreen().catch(() => {
              alert(t("ERROR.EXIT_FULL_SCREEN_MODE"));
            });
          }
          setSessionStorageItem("isFeedbackActive", "true");
          setCameraStopped(true);
          navigate(`/${currentLanguage}/feedback`, {
            state: {
              assessmentTilte: assessmentDetailsData?.title,
              applicantId: assessmentDetailsData?.applicantId,
              assessmentId: assessmentDetailsData?.assessmentId,
            },
          });
        } else {
          resetGivenAns();
          handleApplicantAssessmentQuestion();
        }
      }
    }
  };
  const handleTypeAnswer = (type: string, videoUrl: string) => {
    switch (type) {
      case "Single":
        return { answer: [singleTypeValue], answerVideoUrl: videoUrl };
      case "Multiple":
        return { answer: multipleTypeValue, answerVideoUrl: videoUrl };
      case "Essay":
        return {
          answer:
            essayTypeValue.trim()?.length > charLimit
              ? essayTypeValue.trim().slice(0, charLimit)
              : essayTypeValue.trim(),
          answerVideoUrl: videoUrl,
        };
      case "Video":
        return { answer: transcript, answerVideoUrl: videoUrl };
      case "Coding":
        return {
          answer: btoa(codingAnsTemplate),
          answerVideoUrl: videoUrl,
        };
    }
  };

  const resetGivenAns = () => {
    setSingleTypeValue(null);
    setMultipleTypeValue([]);
    setEssayTypeValue("");
    setEssayCharCount(0);
    setCodingAnsTemplate("");
    setSelectedLanguage("c");
  };
  const handleApplicantAssessmentQuestion = async () => {
    setIsReport(false);
    SetIsLastReportQuestion(false);
    setAddReport("");
    resetTranscript();
    setTranscriptEnabled(false);
    setIsBlinking(false);
    setIsTextToSpeechFinished(false);
    setIsTimerComplete(false);
    setTestCases([]);
    setCodeOutput("");
    SetIsCodingQuestionEdited(false);
    SetIsStartRecording(false);
    resetGivenAns();
    removeSessionStorageItem("isStatusUpdate");
    const isFeedbackActive = getSessionStorageItem("isFeedbackActive");
    if (isFeedbackActive !== "true") {
      const questionData = await getApplicantAssessmentQuestion(
        assessmentDetailsData?.applicantId,
        assessmentDetailsData?.assessmentId,
      );

      if (questionData?.status === 200 && questionData?.data) {
        // Introduce a delay of 1 second
        await new Promise((resolve) => setTimeout(resolve, 1000));

        await updateAssessmentApplicantQuestionStatus({
          assessmentApplicantQuestionId:
            questionData?.data?.assessmentApplicantQuestionId,
          status: "displayed",
        });
        setQuestionData(questionData?.data);
        setSubTimer(questionData?.data?.timeLimit * 60);
        setApiError(true);
        setStartQuestionLoader(false);
        setSubTimerReference(questionData?.data?.timeLimit * 60);
        setCurrentQuestionIndex(questionData?.data?.currentQuestion ?? 1);
        setIsPlaying(true);
        updateProgressBarAndColors(
          questionSet,
          currentQuestionIndex,
          questionData,
          assessmentDetailsData,
          setProgressBar,
          setSubQuestionColors,
          setApiError,
        );
        setSessionStorageItem(
          "currentQuestionId",
          questionData?.data?.assessmentApplicantQuestionId,
        );
        if (questionData?.data?.metaData?.template) {
          setCodingAnsTemplate(
            convertToText(questionData?.data?.metaData?.template),
          );
        }
      } else {
        setApiError(true);

        if (document.fullscreenElement) {
          document.exitFullscreen().catch(() => {
            alert(t("ERROR.EXIT_FULL_SCREEN_MODE"));
          });
        }
        setCameraStopped(true);
        setSessionStorageItem("isFeedbackActive", "true");
        navigate(`/${currentLanguage}/feedback`, {
          state: {
            assessmentTilte: assessmentDetailsData?.title,
            applicantId: assessmentDetailsData?.applicantId,
            assessmentId: assessmentDetailsData?.assessmentId,
          },
        });
      }
    } else {
      setSessionStorageItem("isFeedbackActive", "true");
      setCameraStopped(true);
      navigate(`/${currentLanguage}/feedback`, {
        state: {
          assessmentTilte: assessmentDetailsData?.title,
          applicantId: assessmentDetailsData?.applicantId,
          assessmentId: assessmentDetailsData?.assessmentId,
        },
      });
    }
  };

  // check Internet Speed
  const checkInternetSpeed = async () => {
    try {
      const numTests: number = 10; // Number of tests to perform
      const setInternetSpeedf = (speedInMbps: number | boolean) => {
        setInternetSpeedIsLoading(false);
        if (typeof speedInMbps === "number") {
          setInternetSpeed(true);
          setInternetSpeedCount(parseFloat(speedInMbps.toFixed(2)));
        } else {
          setInternetSpeed(false);
        }
      };

      const testSpeed = async () => {
        try {
          setInternetSpeedIsLoading(true);
          const imageApi: string = "https://picsum.photos/200/300";
          let totalBits: number = 0;

          for (let i = 0; i < numTests; i++) {
            const startTime = Date.now();
            await fetch(imageApi).then((response) => {
              const endTime = Date.now();
              const imageSize = parseInt(
                response.headers.get("content-length") || "0",
              );
              const timeDuration = (endTime - startTime) / 1000; // in seconds
              const loadedBits = imageSize * 8;
              const speedInBps = loadedBits / timeDuration; // bits per second
              totalBits += speedInBps;
            });
          }

          const averageSpeedInMbps =
            (totalBits / (numTests * 1024 * 1024)) * numTests; // Mbps
          setInternetSpeedf(averageSpeedInMbps);
          setInternetSpeed(true);
        } catch (error) {
          console.error("Error testing internet speed:", error);
          setInternetSpeed(false);
          setInternetSpeedIsLoading(false);
        }
      };

      // Initial function to start tests
      const init = async () => {
        await testSpeed();
      };
      init();
    } catch (error) {
      console.error("Error checking internet speed:", error);
      setInternetSpeed(false);
      setInternetSpeedIsLoading(false);
    }
  };

  // retest Internet Connect
  const retestInternetConnect = () => {
    setInternetSpeed(null);
    setInternetSpeedCount(null);
    checkInternetSpeed();
    resetTranscript();
  };

  // handle device changes
  const handleDeviceChange = ({
    cameraCallBack,
    microphoneCallBack,
    // internetCallBack,
  }: any) => {
    if (cameraPermissions.camera !== cameraCallBack) {
      setCameraPermissions({
        camera: cameraCallBack,
      });
    }

    if (micPermissions.mic !== microphoneCallBack) {
      setMicPermissions({
        mic: microphoneCallBack,
      });
    }

    // if (internetSpeed !== internetCallBack) {
    //   if (navigator.onLine) {
    //     setInternetSpeed(true);
    //     checkInternetSpeed();
    //   } else {
    //     setInternetSpeed(false);
    //     setInternetSpeedCount(null);
    //   }
    // }

    if (
      cameraCallBack &&
      microphoneCallBack
      // &&
      // internetCallBack &&
      // internetSpeedCount != null
    ) {
      setIsResumeDisable(false);
      setTranscriptEnabled(true);
    } else if (
      cameraCallBack === false ||
      microphoneCallBack === false
      // ||
      // internetCallBack === false
    ) {
      setIsCheckCompatibilities(true);
      setIsResumeDisable(true);
      setTranscriptEnabled(false);
    }
  };

  // handle Modal Save function
  const handleSystemModalSave = () => {
    setIsCheckCompatibilities(false);
    resetGivenAns();
    handleApplicantAssessmentQuestion();
  };
  const handleSubmitAnswer = (imagePathUrlNew: string) => {
    handleNext(imagePathUrlNew);
  };
  const toCaptureRef = useRef(null);
  const handleSubmitReport = async () => {
    SetReportLoading(true);
    const res = await captureScreenshot(toCaptureRef);
    const uploadedData = await ImageUploader(
      res,
      `reportedQuestion/${assessmentDetailsData?.applicantId}/${questionData?.questionId}`,
    );
    if (uploadedData?.fileName) {
      const reportData = {
        assessmentId: assessmentDetailsData?.assessmentId,
        questionId: questionData?.questionId,
        assessmentApplicantQuestionId:
          questionData?.assessmentApplicantQuestionId,
        question: questionData?.question?.question || questionData?.question,
        questionType: questionData?.type,
        comment: addReport,
        reportedById: assessmentDetailsData?.applicantId,
        attachment: uploadedData?.fileName,
      };
      const reportRes = await assessmentQuestionReport(reportData);
      if (reportRes?.status === 200) {
        if (reportRes?.data?.data?.reportCountExceed) {
          SetIsAbortedPopup(true);
        } else {
          SetIsLastReportQuestion(true);
          showToast(reportRes?.data?.customMessage, "success");
          setAddReport("");
          setIsReport(!isReport);
          setSessionStorageItem("isReport", true);
          setSessionStorageItem("isStatusUpdate", "reported");
          resetGivenAns();
          handleAnswer();
        }
        SetReportLoading(false);
      }
    } else {
      SetReportLoading(false);
      showToast(t("ERROR.CANNOT_REPORT"), "error");
    }
  };
  const handleExitForNow = () => {
    exitFullScreen();
    window.history.back();
    window.close();
    setIsDefferedConfirm(false);
  };
  const handleWalkthroughComplete = () => {
    setIsHeaderWalkthroughDone(false);
  };
  const skillNameRef: any = useRef(null);
  const questionTextRef: any = useRef(null);
  const activeTimerRef: any = useRef(null);
  const reportBtnRef: any = useRef(null);
  const skipBtnRef: any = useRef(null);
  const nextQuestRef: any = useRef(null);
  const instructionsRef: any = useRef(null);
  const exitInterviewRef: any = useRef(null);
  const micImgRef: any = useRef(null);
  const walkthroughSteps =
    (questionData?.types ?? questionData?.type === "Video")
      ? [
        { content: t("GENERAL.SKILL_NAME"), ref: skillNameRef },
        { content: t("GENERAL.THIS_IS_QUES"), ref: questionTextRef },
        {
          content: t("GENERAL.ALLOTTED_TIME"),
          ref: activeTimerRef,
        },
        {
          content: t("GENERAL.MICROPHONE_SIGNAL"),
          ref: micImgRef,
        },
        {
          content: t("GENERAL.PROBLEM_IN_QUES"),
          ref: reportBtnRef,
        },
        { content: t("GENERAL.SKIP_QUESTION"), ref: skipBtnRef },
        {
          content: t("GENERAL.SWITCH_NEXT_QUESTION"),
          ref: nextQuestRef,
        },
      ]
      : (questionData?.types ?? questionData?.type === "Coding")
        ? [
          { content: t("GENERAL.THIS_IS_QUES"), ref: questionTextRef },
          {
            content: t("GENERAL.ALLOTTED_TIME"),
            ref: activeTimerRef,
          },
          {
            content: t("GENERAL.QUESTION_INAPPROPRIATE"),
            ref: reportBtnRef,
          },
          { content: t("GENERAL.SKIP_QUESTION"), ref: skipBtnRef },
          {
            content: t("GENERAL.SWITCH_NEXT_QUESTION"),
            ref: nextQuestRef,
          },
        ]
        : (questionData?.types ?? questionData?.isCustomQuestion)
          ? [
            { content: t("GENERAL.THIS_IS_QUES"), ref: questionTextRef },
            {
              content: t("GENERAL.ALLOTTED_TIME"),
              ref: activeTimerRef,
            },
            { content: t("GENERAL.SKIP_QUESTION"), ref: skipBtnRef },
            {
              content: t("GENERAL.SWITCH_NEXT_QUESTION"),
              ref: nextQuestRef,
            },
          ]
          : [
            { content: t("GENERAL.SKILL_NAME"), ref: skillNameRef },
            { content: t("GENERAL.THIS_IS_QUES"), ref: questionTextRef },
            {
              content: t("GENERAL.ALLOTTED_TIME"),
              ref: activeTimerRef,
            },
            {
              content: t("GENERAL.PROBLEM_IN_QUES"),
              ref: reportBtnRef,
            },
            { content: t("GENERAL.SKIP_QUESTION"), ref: skipBtnRef },
            {
              content: t("GENERAL.SWITCH_NEXT_QUESTION"),
              ref: nextQuestRef,
            },
          ];
  return (
    <>
      <div className={`questionList ${isBlinking ? "countDown" : ""}`}>
        <SubmitAssessmentHeader
          isMenuHide={true}
          stepsArray={[
            { content: t("GENERAL.READ_INSTRUCTION"), ref: instructionsRef },
            { content: t("GENERAL.EXIT_INTERVIEW"), ref: exitInterviewRef },
          ]}
          overlayHeight={20}
          overlayTop={-10}
          overlayWidth={30}
          overlayLeft={-15}
          hideHeaderWalkthrough={!startWalkthrough}
          isNavbarVisible={false}
          activeTimerRef={activeTimerRef}
          isBlinking={isBlinking}
          subTimer={subTimer}
          showGuide={true}
        >
          <div className="header-items">
            <span className="attempt-text">
              {/* Convert this text into multiple languages when reviewing text */}
              This is your
              <span className="highlight">
                <OrdinalShift number={questionData?.totalAttempts} />{" "}
                &nbsp;attempt
              </span>
            </span>
            {isHeaderWalkthroughDone && (
              <Walkthrough
                steps={walkthroughSteps}
                onComplete={handleWalkthroughComplete}
                hasPreviousButton={true}
                showSkipNextTogether={true}
                offsetTop={-5}
                offsetLeft={-5}
                offsetWidth={+12}
                offsetHeight={+10}
              />
            )}
            <ButtonWrapper text="" onClick={() => { }}>
              <div className="instrunctioPopup" ref={instructionsRef}>
                <button className="instructionBtn" onClick={handleShow}>
                  {t("GENERAL.INSTRUCTIONS")}
                </button>
                <InstructionModal
                  show={show}
                  handleClose={handleClose}
                  handleShow={handleShow}
                  instruction={instructions}
                />
                <SubmitAssessmentCalender
                  classname="calender"
                  width="17"
                  height="20"
                />
              </div>
            </ButtonWrapper>
            <div ref={exitInterviewRef}>
              <AssessmentButton
                className="lightBtn logoutBtn"
                onClick={() => {
                  setIsDefferedConfirm(true);
                }}
              >
                {t("GENERAL.DEFFERED")}
              </AssessmentButton>
            </div>
          </div>
        </SubmitAssessmentHeader>
        {isPlaying && (
          <PlayVoice
            qNo={currentQuestionIndex}
            qType={questionData?.type?.toLowerCase()}
            qMins={questionData?.timeLimit}
            onAudioEnd={handleAudioEnd}
            isPlaying={isPlaying}
          />
        )}
        <div className="container-fluid mt-1" ref={toCaptureRef}>
          <div className="title">
            <div className="d-flex gap-2 w-100 justify-content-between">
              <h5 className="assessmenttitle">
                {assessmentDetailsData?.title}{" "}
              </h5>
            </div>
          </div>
          <QuestionProgressBar
            questionSet={questionSet}
            progressbar={progressbar?.progressbar}
            subQuestionColors={subQuestionColors}
          />
          {isDefferedConfirm && (
            <ConfirmPopup
              showDelete={true}
              attempt={questionData?.totalAttempts}
              yesCallback={handleExitForNow}
              noCallback={() => setIsDefferedConfirm(false)}
            />
          )}

          {/* question set with video tag */}
          <AnswerQuestion
            ref={recorderRef}
            skillNameRef={skillNameRef}
            questionTextRef={questionTextRef}
            activeTimerRef={activeTimerRef}
            micImgRef={micImgRef}
            setSingleTypeValue={setSingleTypeValue}
            singleTypeValue={singleTypeValue}
            setMultipleTypeValue={setMultipleTypeValue}
            multipleTypeValue={multipleTypeValue}
            setEssayTypeValue={setEssayTypeValue}
            essayTypeValue={essayTypeValue}
            SpeechRecognition={SpeechRecognition}
            browserSupportsSpeechRecognition={browserSupportsSpeechRecognition}
            transcript={transcript}
            questionData={questionData}
            subTimer={subTimer}
            currentQuestionIndex={currentQuestionIndex}
            transcriptEnabled={transcriptEnabled}
            codingAnsTemplate={codingAnsTemplate}
            setCodingAnsTemplate={setCodingAnsTemplate}
            codeOutPut={codeOutPut}
            testCases={testCases}
            setTestCases={setTestCases}
            setCodeOutput={setCodeOutput}
            handleSubmitAnswer={handleSubmitAnswer}
            startQuestionLoader={startQuestionLoader}
            setStartQuestionLoader={setStartQuestionLoader}
            isBlinking={isBlinking}
            SetIsCodingQuestionEdited={SetIsCodingQuestionEdited}
            isStartRecording={isStartRecording}
            cameraStopped={cameraStopped}
            essayCharCount={essayCharCount}
            setEssayCharCount={setEssayCharCount}
            setCodingSummary={setCodingSummary}
            setDisableNext={setDisableNext}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
          />
          <div className="iteration mt-3 mb-3">
            {questionData?.isCustomQuestion ? (
              <div></div>
            ) : (
              <div>
                <p
                  onClick={() => {
                    setIsReport(!isReport);
                  }}
                >
                  {t("SUBMIT_ASSESSMENT_SOMETHING_WRONG_WITH_THIS_QUESTION")}
                  <span className="reportIt" ref={reportBtnRef}>
                    {t("SUBMIT_ASSESSMENT_REPORT_THIS_QUESTION")}
                  </span>
                </p>
              </div>
            )}
            <div className="d-flex gap-3 align-items-baseline">
              <div className="recordingAction">
                <div ref={activeTimerRef} className="globalTime">
                  <div
                    className={`${isStartRecording && !startQuestionLoader && "recordingIconBlink"} recordingIcon`}
                  >
                    <RecordingIcon />
                  </div>
                  <span className={` ${isBlinking && "globalTimeBlink"} timer`}>
                    {formatTime(subTimer) ?? 0}
                  </span>
                </div>
              </div>
              {currentQuestionIndex < assessmentDetailsData?.totalQuestions && (
                <div ref={skipBtnRef}>
                  <AssessmentButton
                    className="skipButton"
                    onClick={() => {
                      setAddReport("");
                      setIsReport(false);
                      setSessionStorageItem("isStatusUpdate", "skipped");
                      setIsStatus("skipped");
                      handleAnswer();
                    }}
                    disabled={
                      isCheckCompatibilities ||
                      !isTextToSpeechFinished ||
                      startQuestionLoader
                    }
                  >
                    {t("GENERAL.SKIP")}
                  </AssessmentButton>
                </div>
              )}
              {/* only for skip and submit */}
              {assessmentDetailsData?.totalQuestions ===
                currentQuestionIndex && (
                  <div className="zIndex">
                    <AssessmentButton
                      disabled={
                        isCheckCompatibilities ||
                        !isTextToSpeechFinished ||
                        startQuestionLoader
                      }
                      onClick={() => {
                        setAddReport("");
                        setIsReport(false);
                        setSessionStorageItem("isStatusUpdate", "skipped");
                        setIsStatus("");
                        handleAnswer();
                      }}
                    >
                      {t("GENERAL.SKIP_AND_SUBMIT")}
                    </AssessmentButton>
                  </div>
                )}
              <div ref={nextQuestRef} className="zIndex">
                <AssessmentButton
                  disabled={
                    questionData?.type === "Video" &&
                      isFirefox &&
                      isTextToSpeechFinished
                      ? false
                      : (essayTypeValue?.length > charLimit ? true : false) ||
                      isCheckCompatibilities ||
                      !isTextToSpeechFinished ||
                      disableNext
                  }
                  onClick={() => {
                    setAddReport("");
                    setIsReport(false);
                    setDisableNext(true);
                    setSessionStorageItem("isStatusUpdate", "answered");
                    setIsStatus("answered");
                    handleAnswer();
                  }}
                >
                  {assessmentDetailsData?.totalQuestions ===
                    currentQuestionIndex
                    ? t("GENERAL.SUBMIT")
                    : t("GENERAL.NEXT.QUESTION")}
                </AssessmentButton>
              </div>
            </div>
          </div>
          {isReport && (
            <div>
              <AddReport
                value={addReport}
                placeHolder={t("SUBMIT_ASSESSMENT.REPORT_YOUR_QUERY")}
                btnName={t("GENERAL.REPORT")}
                setFn={setAddReport}
                handleSubmit={handleSubmitReport}
                reportLoading={reportLoading}
              />
            </div>
          )}
        </div>

        {isCheckCompatibilities && (
          <CustomModal
            show={isCheckCompatibilities}
            isSaveEnable={true}
            instructionHeadTitle={t("SYSTEM_COMPATIBILITY_CHECKS")}
            saveButtonText="Resume"
            handleSave={handleSystemModalSave}
            isSaveDisable={isResumeDisable}
          >
            <div className="compatibilityModal">
              <SystemCompatibility
                micPermissions={micPermissions}
                checkMicPermissions={() => { }}
                checkCameraPermission={() => { }}
                checkInternetSpeed={checkInternetSpeed}
                cameraPermissions={cameraPermissions}
                internetSpeed={internetSpeed}
                internetSpeedIsLoading={internetSpeedIsLoading}
                retestInternetConnect={retestInternetConnect}
                internetSpeedCount={internetSpeedCount}
                capturedPic={true}
                captureImageCallBack={() => { }}
                videoRef={videoContinueRef}
                headerVisible={false}
              />
            </div>
          </CustomModal>
        )}
        <DeviceDetector
          onDeviceChange={handleDeviceChange}
          videoRef={videoContinueRef}
          isCheckCamerapermission={true}
          isCheckMicpermission={true}
          isCheckInternetpermission={true}
        />
      </div>

      {isTabSwitchedBack && (
        <CustomModal
          show={isTabSwitchedBack}
          isSaveEnable={true}
          saveButtonText={t("GENERAL.OK")}
          isHeaderVisible={false}
          isFooterVisible={true}
          handleSave={handleTabChangeModalSave}
        >
          <div className="tabchangepopup">
            <span>{t("SUBMIT_ASSESSMENT_TAB_CHANGE_TEXT")}</span>
          </div>
        </CustomModal>
      )}
      {isAbortedPopup && (
        <CustomModal
          show={isAbortedPopup}
          isSaveEnable={true}
          saveButtonText={t("GENERAL.OK")}
          isHeaderVisible={false}
          isFooterVisible={true}
          handleSave={handleAbortedModalSave}
        >
          <div className="tabchangepopup">
            <div className="reportedPopup">
              <span>{t("GENERAL.ALERT")}</span>
              <span>{t("SUBMIT_ASSESSMENT_ABORTED_TEXT")}</span>
            </div>
          </div>
          {/* <div className="abortedTimer">{abortedTimer}</div> */}
        </CustomModal>
      )}
      <Footer />
    </>
  );
};

export default QuestionList;
